import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCalendarPlus } from '@fortawesome/pro-solid-svg-icons/faCalendarPlus';
import { faCalendarDay } from '@fortawesome/pro-solid-svg-icons/faCalendarDay';
import { faCalendarWeek } from '@fortawesome/pro-solid-svg-icons/faCalendarWeek';
import { faCalendarPlus as farCalendarPlus } from '@fortawesome/pro-regular-svg-icons/faCalendarPlus';
import { faHistory } from '@fortawesome/pro-solid-svg-icons/faHistory';
import { faList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faBars as farBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faQuestionCircle as falQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faTimesCircle as falTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { faInfoCircle as falInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faPlus as farPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faHourglassHalf } from '@fortawesome/pro-solid-svg-icons/faHourglassHalf';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faCheckSquare as farCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import { faSquare as farSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faMapSigns } from '@fortawesome/pro-solid-svg-icons/faMapSigns';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCalendarCheck } from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import { faChevronCircleDown } from '@fortawesome/pro-solid-svg-icons/faChevronCircleDown';
import { faChevronCircleUp } from '@fortawesome/pro-solid-svg-icons/faChevronCircleUp';
import { faAngleLeft as farAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import { faAngleDoubleLeft as farAngleDoubleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleDoubleLeft';
import { faAngleRight as farAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faAngleDoubleRight as farAngleDoubleRight } from '@fortawesome/pro-regular-svg-icons/faAngleDoubleRight';
import { faSync as farSync } from '@fortawesome/pro-regular-svg-icons/faSync';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faEdit } from '@fortawesome/pro-solid-svg-icons/faEdit';
import { faUserClock } from '@fortawesome/pro-solid-svg-icons/faUserClock';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faArrowAltUp } from '@fortawesome/pro-solid-svg-icons/faArrowAltUp';
import { faArrowAltDown } from '@fortawesome/pro-solid-svg-icons/faArrowAltDown';
import { faBalanceScale } from '@fortawesome/pro-solid-svg-icons/faBalanceScale';
import { faBalanceScaleLeft } from '@fortawesome/pro-solid-svg-icons/faBalanceScaleLeft';
import { faBalanceScaleRight } from '@fortawesome/pro-solid-svg-icons/faBalanceScaleRight';
import { faChartArea } from '@fortawesome/pro-solid-svg-icons/faChartArea';
import { faCalendarTimes } from '@fortawesome/pro-solid-svg-icons/faCalendarTimes';
import { faSpinnerThird as farSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';

export const initFontAwesome = () =>
  library.add(
    faChevronLeft,
    faChevronRight,
    faCalendarPlus,
    faCalendarDay,
    faCalendarWeek,
    farCalendarPlus,
    faList,
    faHistory,
    faUsers,
    farBars,
    falQuestionCircle,
    falCheckCircle,
    falTimesCircle,
    falInfoCircle,
    farPlus,
    faHourglassHalf,
    faExclamationCircle,
    farCheckSquare,
    farSquare,
    faMapSigns,
    faClock,
    faCalendar,
    faCalendarCheck,
    faCog,
    faCheck,
    faQuestionCircle,
    faCheckCircle,
    faInfoCircle,
    faTimesCircle,
    faChevronUp,
    faChevronDown,
    faKey,
    faUserCircle,
    faChevronCircleDown,
    faChevronCircleUp,
    farAngleLeft,
    farAngleDoubleLeft,
    farAngleRight,
    farAngleDoubleRight,
    farSync,
    faSearch,
    faTimes,
    faPlus,
    faEdit,
    faUserClock,
    faBriefcase,
    faArrowAltUp,
    faArrowAltDown,
    faBalanceScale,
    faBalanceScaleLeft,
    faBalanceScaleRight,
    faChartArea,
    faCalendarTimes,
    farSpinnerThird,
    faGlobe,
    faLock
  );
